module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumSB.0e539a5.woff";